export enum LogLevelType {
  Error = "ERROR",
  Info = "INFO",
  Warning = "WARNING",
}
